import React from 'react';
import { Typography } from '@mui/material';
import { COLOR_TEXT_1 } from 'src/utils/colors';

const SubHeading = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography
      variant="h6"
      sx={{
        fontWeight: 700,
        color: COLOR_TEXT_1,
        my: 3,
      }}
    >
      {children}
    </Typography>
  );
};

export default SubHeading;
